import { render } from "./bank.vue?vue&type=template&id=1d47272d&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"

import "./bank.vue?vue&type=style&index=0&id=1d47272d&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d47272d"]])

export default __exports__